import { fieldOk } from "@/lib/post/fieldValidation"
import { STYLE_SLIDER_AXES } from "@/lib/post/options"
import { coverDesign } from "@/lib/post/services/coverDesign"

// Open House — a bundle's cover brief (OrderBriefs::CoverBrief) asks today's
// cover questions, so it renders today's cover form's own field definitions
// (lib/post/services/coverDesign.js) through today's FieldRenderer: their
// labels, options, help, pickers and sliders, in today's order. Only the answers
// the server asks this order for (`brief.fields`) appear, with its required
// flags. A step whose one question has no label of its own (design samples,
// palettes, style) takes today's step heading and line as its label and help.
// Today's requirements file question is where the brief's reference file goes.

const STEPS = ["details", "samples", "palette", "style"]
const FILE_KEY = "reference_files"

export const COVER_FILE = coverDesign.steps().find((step) => step.id === "details")
  .fields.find((field) => field.key === "file")

export function coverQuestions(briefFields) {
  const required = Object.fromEntries(briefFields.map((field) => [field.key, field.required]))

  return coverDesign.steps().filter((step) => STEPS.includes(step.id)).flatMap((step) =>
    step.fields.flatMap((field) => {
      const key = field.key === "file" ? FILE_KEY : field.key
      if (!(key in required)) return []

      const label = field.label ?? step.title
      const help = field.help ?? (field.label ? undefined : step.sub)
      return [{ ...field, key, label, help, required: required[key] }]
    }))
}

// The style answer arrives and saves as one object by slider; the sliders read
// and set each one as its own value.
export const spreadStyle = ({ style, ...answers }) => ({ ...answers, ...style })

export const styleAnswer = (values) => {
  const moved = STYLE_SLIDER_AXES.filter((axis) => values[axis.key] != null)
  return moved.length ? Object.fromEntries(moved.map((axis) => [axis.key, values[axis.key]])) : null
}

// A required question today's form would not let past (fieldOk), by key.
export const missingCover = (questions, values) =>
  questions.filter((field) => field.required && field.key !== FILE_KEY && !fieldOk(field, values)).map((field) => field.key)
